<template lang="pug">
#transation-management
    v-banner.title-banner(min-height="88")
        .text-h4.font-weight-bold {{ $t('Menu.__Accounting') + ' : ' + $t('Menu.__Transaction') }}
        template(v-slot:actions)
            //- v-btn.ml-6(rounded color="primary" @click="addItem")  {{$t('Transactions.__AddTransaction')}}
            v-menu(open-on-hover, offset-y)
                template(v-slot:activator="{ on }")
                    v-btn(rounded, v-on="on", color="primary") 
                        | {{ $t('Transactions.__AddTransaction') }}
                        v-icon(right, dark) keyboard_arrow_down
                v-list
                    v-list-item(@click="addItem('Income')")
                        v-list-item-title {{ $t('Transactions.__Income') }}
                    v-list-item(@click="addItem('Expense')")
                        v-list-item-title {{ $t('Transactions.__Expenses') }}
                    v-list-item(@click="addItem('Journal')")
                        v-list-item-title {{ $t('Transactions.__Journal') }}

    v-container
        Alert
        v-row
            v-col.d-flex.align-center(v-if="selected.length > 0")
                v-btn(
                    outlined,
                    rounded,
                    color="red",
                    @click="batchDeleteDialog = true"
                ) {{ $t('ActionOption.__Delete') }}
            v-spacer
            v-col.d-flex.align-center.justify-end(cols="12" md="4")
                v-btn.mr-4(outlined, rounded, @click="filterDialog = true") {{ $t('Transactions.__Filter') }}
                v-btn.mr-4(outlined, rounded, @click="clearFilterDialog();getTransactions()", color="lightGray", width="112") {{ $t('ActionOption.__ClearAll') }}
            v-col(cols="12" md="4")
                v-text-field(
                    v-model="filters.search",
                    solo,
                    dense,
                    clearable,
                    outlined,
                    hide-details,
                    append-outer-icon="search",
                    @click:append-outer="drawer=false;options.page=1;getTransactions()",
                    @click:clear="delete filters.search;drawer=false;getTransactions()"
                )
        v-row
            v-col(:md="drawer? '6' : '12'" :lg="drawer? '8' : '12'" :class="($vuetify.breakpoint.name=='xs'||$vuetify.breakpoint.name=='sm') && drawer? 'd-none': ''")
                v-data-table(:item-class="getRowClass" v-model="selected" :items="transactions" :headers="headers" hide-default-footer item-key="id" show-select @click:row="editItem" :options.sync="options" :loading="loading" :custom-sort="defaultDataSort")
                    template(v-slot:item.description="{ item }")
                        span(v-if="item.entryResource && item.entryResource.type=='Bill'") {{$t("Transactions.__BillPayment")}}
                        span(v-else-if="item.entryResource && item.entryResource.type=='Invoice'") {{$t("Transactions.__InvoicePayment")}}
                        span(v-else-if="item.entryResource && item.entryResource.type=='Receipt'") {{$t("Transactions.__ReceiptPayment")}}
                        span(v-else) {{ item.description }}  
                        span(v-if="item.entryResource && item.entryResource.name != ''") {{item.entryResource.name}}
                        span(v-if="item.entryResource && item.entryResource.number != ''") - {{item.entryResource.number}}
                    
                    template(v-slot:item.date="{ item }") {{ item.date }}
                    template(v-slot:item.amount="{ item }") {{getAmountWithCurrency( item.amount || item.total || 0, currencyCode )}}
                    template(v-slot:item.account="{ item }") {{ item.type == 'Normal' ? getAccountTranslatedName(item.entryLedger.account.name) : $t('Transactions.__Journal') }}
                    template(v-slot:item.isReviewed="{ item }")
                        .text-center
                            v-icon(
                                :color="item.isReviewed ? 'success' : ''"
                            ) check_circle
                    //- template(
                    //-     v-if="transactions.length > 0",
                    //-     v-slot:body="{ items, isSelected, select }"
                    //- )
                    //-     tbody
                    //-         tr.selectable(
                    //-             v-for="item in items",
                    //-             :key="item.id",
                    //-             :style="editedItem.id == item.id ? 'background-color: #eeeeee' : ''",
                    //-             @click="editItem(item)"
                    //-         )
                    //-             td
                    //-                 v-simple-checkbox(
                    //-                     :value="isSelected(item)",
                    //-                     @input="select(item, $event)",
                    //-                     :ripple="false"
                    //-                 )
                    //-             td
                    //-                 span(v-if="item.entryResource && item.entryResource.type=='Bill'") {{$t("Transactions.__BillPayment")}}
                    //-                 span(v-else-if="item.entryResource && item.entryResource.type=='Invoice'") {{$t("Transactions.__InvoicePayment")}}
                    //-                 span(v-else-if="item.entryResource && item.entryResource.type=='Receipt'") {{$t("Transactions.__ReceiptPayment")}}
                    //-                 span(v-else) {{ item.description }}  
                    //-                 span(v-if="item.entryResource && item.entryResource.name != ''") {{item.entryResource.name}}
                    //-                 span(v-if="item.entryResource && item.entryResource.number != ''") - {{item.entryResource.number}}
                    //-             td
                    //-                 | {{ item.date }}
                    //-             td.text-right
                    //-                 | {{getAmountWithCurrency( item.amount || item.total || 0, currencyCode )}}
                    //-             td
                    //-                 | {{ item.type == 'Normal' ? getAccountTranslatedName(item.entryLedger.account.name) : $t('Transactions.__Journal') }}
                    //-             td.text-center
                    //-                 v-icon(
                    //-                     :color="item.isReviewed ? 'success' : ''"
                    //-                 ) check_circle

                v-row.pagination-row
                    v-col.d-flex.align-center.justify-start(cols="6")
                        span.mr-2.d-none.d-md-block {{ $t('Table.__ItemsPerPage') }}
                        span
                            v-select.page-select(
                                v-model="options.itemsPerPage",
                                solo,
                                dense,
                                outlined,
                                hide-details,
                                :items="perPageItems"
                            )
                    v-col.d-flex.align-center.justify-end(cols="6")
                        v-pagination(v-model="options.page", :length="pageCount")

            v-col(v-if="drawer" md="6" lg="4")
                v-card(color="#fdf1eb")
                    v-card-title
                        .title {{drawerTitle}} 
                        v-spacer
                        v-btn(icon, @click="closeEdit")
                            v-icon(color="lightGray") clear
                    v-divider
                    v-card-text
                        v-form.normal-transaction(v-if="editedItem.type == 'Normal'" v-model="formValid" ref="transactionform")
                            v-row
                                v-col
                                    .field-label 
                                        span {{ $t('Transactions.__Description') }}
                                        span.required *
                                    v-text-field(
                                        v-model="editedItem.description",
                                        solo,
                                        dense,
                                        outlined,
                                        hide-details,
                                        :rules="[rules.required]"
                                    ) 
                            v-row
                                v-col
                                    .field-label 
                                        span {{ $t('Transactions.__PaymentAccount') }}
                                        span.required *
                                    AccountSelector(
                                        v-model="editedItem.paymentAccountId",
                                        :group-keys="['Assets', 'Liabilities']",
                                        :exclude-categories="['SaleTaxes']",
                                        hide-details,
                                        :rules="[rules.required]"
                                    )
                                v-col
                                    .field-label 
                                        span {{ $t('Transactions.__Date') }}
                                        span.required *
                                    v-menu(
                                        v-model="editedItem.dateMenu",
                                        offset-y,
                                        :close-on-content-click="false",
                                        :nudge-right="40",
                                        transition="scale-transition",
                                        min-width="290px"
                                    )
                                        template(v-slot:activator="{ on }")
                                            v-text-field(
                                                v-model="editedItem.date",
                                                :rules="[rules.required]",
                                                clearable,
                                                hide-details,
                                                solo,
                                                dense,
                                                outlined,
                                                readonly,
                                                append-icon="event",
                                                v-on="on",
                                                :placeholder="$t('Placeholder.__Date')"
                                            )
                                        v-date-picker(
                                            v-model="editedItem.date",
                                            @input="editedItem.dateMenu = false"
                                            :locale="$store.getters['account/language']() == 'tw'? 'zn-tw': ''"
                                        )

                            v-row
                                v-col
                                    .field-label
                                        span {{ $t('Transactions.__Type') }}
                                        span.required *
                                    v-select(
                                        v-model="editedItem.paymentAction",
                                        :items="transactionTypes",
                                        item-text="name",
                                        item-value="value",
                                        solo,
                                        dense,
                                        outlined,
                                        hide-details,
                                        :rules="[rules.required]",
                                        @input="paymentAction = editedItem.paymentAction"
                                    )
                                v-col
                                    .field-label
                                        span {{ $t('Transactions.__Amount') }}
                                        span.required *
                                    v-text-field(
                                        v-model.number="editedItem.amount",
                                        solo,
                                        dense,
                                        outlined,
                                        hide-details,
                                        type="number",
                                        :rules="[rules.required]",
                                        @input="calculateTaxInfo"
                                    )
                            //- v-row(v-if="paymentAction == 'Withdraw'")
                            //-     v-col
                            //-         .field-label
                            //-             span {{ $t('Transactions.__Vendor') }}
                            //-         VendorSelector(
                            //-             v-model="editedItem.vendor",
                            //-             @input="editedItem.vendorId = editedItem.vendor.id"
                            //-         )
                            v-divider
                            v-row
                                v-col
                                    .field-label
                                        span {{ $t('Transactions.__EntryAccount') }}
                                        span.required *
                                    AccountSelector(v-if="editedItem.paymentAction == 'Withdraw'"
                                        v-model="entryAccount",
                                        hide-details,
                                        :group-keys="['Assets', 'Liabilities','OperatingExpenses','OperatingCosts','OwnersEquity']",
                                        :rules="[rules.required]"
                                        key="1"
                                        :return-object="true",
                                        @input="editedItem.entryAccountId = entryAccount.id;"
                                    )
                                    AccountSelector(v-if="editedItem.paymentAction == 'Deposit'" 
                                        v-model="entryAccount",
                                        :group-keys="['Assets', 'Liabilities','Income','OwnersEquity']",
                                        hide-details,
                                        :rules="[rules.required]"
                                        key="2"
                                        :return-object="true"
                                        @input="editedItem.entryAccountId = entryAccount.id;"
                                    )
                                    //- span {{entryAccount}}
                            //- v-row
                            //-     v-col
                            //-         .field-label
                            //-             span {{ $t('Transactions.__Customer') }}
                            //-         CustomerSelector(
                            //-             v-model="editedItem.customer",
                            //-             @input="editedItem.customerId = editedItem.customer.id"
                            //-         )
                            v-row(v-if="entryAccount!=null && entryAccount.category != 'SaleTaxes'")
                                v-col
                                    .field-label
                                        span {{ $t('Transactions.__Taxes') }}
                                    TaxesSelector(
                                        v-model="editedItem.taxes",
                                        hide-details,
                                        @input="taxesUpdated"
                                    )
                                    .tax-info.float-right.ma-2
                                        span {{ $t('Transactions.__TaxesIncluded') }} {{ getAmountWithCurrency(totlaTaxesAmount || 0, currencyCode) }}
                                        v-menu(
                                            v-if="(editedItem.taxes && editedItem.taxes.length > 0) || false",
                                            v-model="taxesInfoPopup",
                                            open-on-hover,
                                            :close-on-content-click="false",
                                            :nudge-width="200",
                                            offset-x,
                                            left
                                        )
                                            template(
                                                v-slot:activator="{ on, attrs }"
                                            )
                                                a.ml-3(
                                                    text,
                                                    color="promary",
                                                    v-bind="attrs",
                                                    v-on="on"
                                                ) {{$t("Transactions.__Detail")}}
                                            v-card
                                                v-card-text
                                                    .tax-detail(
                                                        v-for="tax in editedItem.taxes"
                                                    )
                                                        span {{ tax.name }} ({{ tax.rate }}%)
                                                        span.float-right {{ getAmountWithCurrency(tax.amount || 0, currencyCode ) }}
                                                    v-divider.my-2
                                                    .tax-info
                                                        span {{ $t('Transactions.__BeforeTaxAmount') }}
                                                        span.float-right {{ getAmountWithCurrency(beforeTaxesAmount || 0, currencyCode ) }}
                                                    .tax-info
                                                        span {{ $t('Transactions.__TaxAmount') }}
                                                        span.float-right {{ getAmountWithCurrency(totlaTaxesAmount || 0 , currencyCode )}}
                                                    .tax-info
                                                        span {{ $t('Transactions.__AfterTaxAmount') }}
                                                        span.float-right {{ getAmountWithCurrency(editedItem.amount || 0, currencyCode ) }}

                            //- v-row
                            //-     v-col.d-flex.align-center.justify-end
                            //-         v-btn(color="primary" text) {{$t("__AddCustomer")}}
                            //-         .dot ．
                            //-         v-btn(color="primary" text) {{$t("添加稅項")}}
                            v-divider
                            v-row
                                v-col
                                    .field-label
                                        span {{ $t('Transactions.__Notes') }}
                                    v-textarea(
                                        v-model="editedItem.note",
                                        solo,
                                        outlined,
                                        height="80",
                                        :placeholder="$t('Transactions.__Notes')",
                                        hide-details
                                    )
                            //- v-row
                            //-     v-col
                            //-         .text 本交易最後更新時間：2020/03/20
                        v-form.journal-transactions(v-if="editedItem.type == 'Journal'" v-model="formValid" ref="transactionform")
                            v-row
                                v-col
                                    .field-label 
                                        span {{ $t('Transactions.__Description') }}
                                        span.required *
                                    v-text-field(
                                        v-model="editedItem.description",
                                        solo,
                                        dense,
                                        outlined,
                                        hide-details,
                                        :rules="[rules.required]"
                                    ) 
                            v-row
                                v-col
                                    .field-label 
                                        span {{ $t('Transactions.__Date') }}
                                        span.required *
                                    v-menu(
                                        v-model="editedItem.dateMenu",
                                        offset-y,
                                        :close-on-content-click="false",
                                        :nudge-right="40",
                                        transition="scale-transition",
                                        min-width="290px"
                                    )
                                        template(v-slot:activator="{ on }")
                                            v-text-field(
                                                v-model="editedItem.date",
                                                clearable,
                                                hide-details,
                                                solo,
                                                dense,
                                                outlined,
                                                readonly,
                                                append-icon="event",
                                                v-on="on",
                                                :rules="[rules.required]",
                                                :placeholder="$t('Placeholder.__Date')"
                                            )
                                        v-date-picker(
                                            v-model="editedItem.date",
                                            @input="editedItem.dateMenu = false"
                                            :locale="$store.getters['account/language']() == 'tw'? 'zn-tw': ''"
                                        )
                                v-col
                                    .field-label.d-flex.align-center.justify-end
                                        span {{ $t('Transactions.__Amount') }}
                                    h1.float-right.my-2
                                        | $ {{ editedItem.total || 0 }}
                            v-row
                                v-col
                                    h4.mb-2 {{ $t('Transactions.__Debits') }}
                                    v-divider
                            template(
                                v-for="(ledger, idx) in editedItem.debits"
                            )
                                v-row
                                    v-col.d-flex.align-center.justify-start
                                        AccountSelector.mr-3(
                                            v-model="ledger.accountId",
                                            :rules="[rules.required]",
                                            :excludeCategories="['SaleTaxes']"
                                            hide-details
                                        )
                                        v-btn(
                                            icon,
                                            color="primary",
                                            width="40px",
                                            @click="deleteLedgerItem('Debit',idx)"
                                        )
                                            v-icon delete

                                v-row.mr-10
                                    v-col
                                        v-text-field(
                                            v-model.number="ledger.amount",
                                            :min="0",
                                            solo,
                                            dense,
                                            outlined,
                                            hide-details,
                                            :rules="[rules.required]",
                                            @input="updateJournalAmount"
                                        )
                                    v-col

                            
                            v-row
                                v-col
                                    h4.mb-2 {{ $t('Transactions.__Credits') }}
                                    v-divider
                            template(
                                v-for="(ledger, idx) in editedItem.credits"
                            )
                                v-row
                                    v-col.d-flex.align-center.justify-start
                                        AccountSelector.mr-3(
                                            v-model="ledger.accountId",
                                            :rules="[rules.required]",
                                            :excludeCategories="['SaleTaxes']"
                                            hide-details
                                        )
                                        v-btn(
                                            icon,
                                            color="primary",
                                            width="40px",
                                            @click="deleteLedgerItem('Credit',idx)"
                                        )
                                            v-icon delete

                                v-row.mr-10
                                    v-col
                                    v-col
                                        v-text-field(
                                            v-model.number="ledger.amount",
                                            v-if="ledger.direction == 'Credit'",
                                            :min="0",
                                            solo,
                                            dense,
                                            outlined,
                                            hide-details,
                                            :rules="[rules.required]",
                                            @input="updateJournalAmount"
                                        )

                            v-row.mr-10
                                v-col.text-center
                                    v-divider
                                    v-btn.my-3(
                                        rounded,
                                        outlined,
                                        @click="addLedgerItem('Debit')"
                                    ) {{ $t('Transactions.__AddDebit') }}
                                    h6 {{ $t('Transactions.__TotalDebit') }}
                                    h3 $ {{ this.editedItem.totalDebitAmount || 0 }}
                                v-col.text-center
                                    v-divider
                                    v-btn.my-3(
                                        rounded,
                                        outlined,
                                        @click="addLedgerItem('Credit')"
                                    ) {{ $t('Transactions.__AddCredit') }}
                                    h6 {{ $t('Transactions.__TotalCredit') }}
                                    h3 $ {{ this.editedItem.totalCreditAmount || 0 }}
                            v-row
                                v-col
                                    .field-label
                                        span {{ $t('Transactions.__Notes') }}
                                    v-textarea(
                                        v-model="editedItem.note",
                                        solo,
                                        outlined,
                                        height="80",
                                        :placeholder="$t('Transactions.__Notes')",
                                        hide-details
                                    )
                            v-row
                                v-col
                                    .primary--text(v-if="unbalanced") {{ $t('Transactions.__UnbalancedNote') }}

                    v-divider
                    v-card-actions
                        v-row
                            v-col.d-flex.align-center.justify-start
                                v-btn(
                                    v-if="editedItem.id != undefined",
                                    icon,
                                    @click="deleteDialog = true"
                                ) 
                                    v-icon delete
                                v-btn(icon, @click="duplicateTransaction") 
                                    v-icon file_copy
                            v-col.d-flex.align-center.justify-end
                                v-btn.mr-6(
                                    @click="updateIsReviewed",
                                    outlined,
                                    rounded,
                                    min-width="112"
                                ) {{ editedItem.isReviewed ? $t('Transactions.__MarkNotReviewed') : $t('Transactions.__MarkReviewed') }}
                                v-btn(
                                    rounded,
                                    dark,
                                    @click="saveItem",
                                    color="primary",
                                    min-width="112"
                                ) {{ $t('ActionOption.__Save') }}

    ConfirmDialog(
        v-model="deleteDialog",
        :title="$t('Transactions.__DeleteTransaction')",
        :message="$t('Transactions.__ConfirmDeleteTransaction')",
        :cancel-text="$t('ActionOption.__Cancel')",
        :confirm-text="$t('ActionOption.__Delete')",
        :confirm-action="deleteEditTransaction"
    )
    ConfirmDialog(
        v-model="batchDeleteDialog",
        :title="$t('Transactions.__DeleteTransaction')",
        :message="$t('Transactions.__BatchDeleteTransaction', { num: selected.length })",
        :cancel-text="$t('ActionOption.__Cancel')",
        :confirm-text="$t('ActionOption.__Delete')",
        :confirm-action="batchDelectTranctions"
    )

    v-dialog(v-model="filterDialog", scrollable, max-width=640, eager)
        v-card 
            v-card-title 
                .title {{ $t('Transactions.__Filter') }}
                v-spacer
                v-btn(icon, @click="filterDialog = false")
                    v-icon(color="lightGray") clear
            v-card-text
                //- .field-label 
                //-     span {{ $t('Transactions.__EntryAccount') }}
                //- AccountSelector(
                //-     v-model="filterItem.accountId",
                //-     :exclude-categories="['SaleTaxes']"
                //- )
                .field-label 
                    span {{ $t('Transactions.__Status') }}
                v-radio-group.d-inline-flex(v-model="filterItem.status")
                    v-radio.mr-8(:key="1" :label="$t('Transactions.__All')" value="")
                    v-radio.mr-8(:key="2" :label="$t('Transactions.__Reviewed')" value="Reviewed")
                    v-radio.mr-8(:key="3" :label="$t('Transactions.__NotReviewed')" value="NotReviewed")
                .field-label 
                    span {{ $t('Transactions.__Type') }}
                .d-inline-flex
                    v-checkbox.mr-8(
                        v-model="filterItem.isDesposit",
                        :label="$t('Transactions.__Deposit')"
                    )
                    v-checkbox.mr-8(
                        v-model="filterItem.isWithdraw",
                        :label="$t('Transactions.__Withdraw')"
                    )
                    v-checkbox.mr-8(
                        v-model="filterItem.isJournal",
                        :label="$t('Transactions.__Journal')"
                    ) 
                .field-label
                    span {{ $t('Transactions.__Date') }}
                v-menu(
                    v-model="rangeDateMenu",
                    offset-y,
                    :close-on-content-click="false",
                    :nudge-right="40",
                    transition="scale-transition",
                    min-width="290px"
                )
                    template(v-slot:activator="{ on }")
                        v-text-field(
                            :value="dateRangeText",
                            clearable,
                            hide-details,
                            solo,
                            dense,
                            outlined,
                            readonly,
                            append-icon="event",
                            v-on="on",
                            :placeholder="$t('Placeholder.__DateRange')",
                            @click:clear="filterItem.dates = []"
                        )
                    v-date-picker(
                        v-model="filterItem.dates",
                        @input="rangeDateMenu = filterItem.dates.length == 2 ? false : true",
                        :locale="$store.getters['account/language']() == 'tw'? 'zn-tw': ''",
                        range
                    )
            v-card-actions.justify-center.mb-6
                v-btn.mr-6(
                    rounded,
                    dark,
                    @click="clearFilterDialog",
                    color="lightGray",
                    width="112"
                ) {{ $t('ActionOption.__ClearAll') }}
                v-btn(
                    rounded,
                    dark,
                    @click="filterTransactions",
                    color="primary",
                    width="112"
                ) {{ $t('Transactions.__Filter') }}
</template>

<script>
import * as TimeHelper from "@/utils/timeHelper"
import * as currencyHelper from "@/utils/currencies"
import * as accountHelper from "@/utils/accountHelper"
import * as textfieldUtils from "@/utils/textfield.js"
import * as datatableHelper from "@/utils/datatableHelper.js"

export default {
  mixins: [currencyHelper.mixin, TimeHelper.mixin, accountHelper.mixin, datatableHelper.mixin],
  data() {
    return {
      perPageItems: [10, 25, 50],
      pageCount: 0,
      options: { page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [] },
      loading: false,
      filters: {},

      rules: textfieldUtils.rules,
      formValid: true,
      searchText: "",
      selected: [],
      paymentAction: "",
      entryAccount: {},
      totlaTaxesAmount: 0,
      beforeTaxesAmount: 0,
      unbalanced: false,
      deleteDialog: false,
      batchDeleteDialog: false,
      taxesInfoPopup: false,
      transactionTypes: [
        { name: this.$t("Transactions.__Withdraw"), value: "Withdraw" },
        { name: this.$t("Transactions.__Deposit"), value: "Deposit" }
      ],
      headers: [
        {
          text: this.$t("Transactions.__Description"),
          align: "start",
          sortable: true,
          value: "description"
        },
        {
          text: this.$t("Transactions.__Date"),
          align: "start",
          sortable: true,
          value: "date"
        },
        {
          text: this.$t("Transactions.__Amount"),
          align: "end",
          sortable: true,
          value: "amount"
        },
        {
          text: this.$t("Transactions.__EntryAccount"),
          align: "start",
          sortable: false,
          value: "account"
        },
        {
          text: this.$t("Transactions.__Reviewed"),
          align: "center",
          sortable: false,
          value: "isReviewed"
        }
      ],
      statusRadioGroup: 1,
      filterDialog: false,
      rawTransactions: [],
      transactions: [],
      filterItem: {
        status: "",
        dates: []
      },
      rangeDateMenu: false,
      drawer: false,
      isEditing: false,
      editedItem: {
        dateMenu: false
      }
    }
  },
  methods: {
    getTransactions() {
      // this.$store.dispatch("global/startLoading")

      if (this.filters.search == null) {
        delete this.filters["search"]
      }
      var query = this.datatableOptionsToQuery(this.options)
      query = Object.assign({}, query, this.filters)
      this.loading = true
      this.$store
        .dispatch("transactions/getTransactions", query)
        .then(
          function(response) {
            this.rawTransactions = this.transactions = response.data
            this.pageCount = response.paging.totalPages
            this.loading = false
            // this.totalPages = response.paging.totalPages

            // this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
            this.loading = false
          }.bind(this)
        )
    },
    getTransaction(tid) {
      this.loading = true
      this.$store
        .dispatch("transactions/getTransaction", tid)
        .then(
          function(response) {
            var transaction = response.data
            if (transaction) {
              this.editItem(transaction)
              this.filters.search = transaction.description
              this.options.page = 1
              this.getTransactions()
            }
            this.loading = false
            // this.totalPages = response.paging.totalPages

            // this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
            this.loading = false
          }.bind(this)
        )
    },
    addItem(type) {
      if (this.$refs.transactionform) {
        this.$refs.transactionform.reset()
      }
      if (type != "Journal") {
        this.editedItem = {
          dateMenu: false,
          type: "Normal",
          taxes: []
        }
        if (type == "Expense") {
          this.editedItem.paymentAction = "Withdraw"
          this.paymentAction = "Withdraw"
        } else if (type == "Income") {
          this.editedItem.paymentAction = "Deposit"
          this.paymentAction = "Deposit"
        }
        this.paymentAction = this.editedItem.paymentAction
      } else {
        this.editedItem = {
          dateMenu: false,
          type: "Journal",
          debits: [{ direction: "Debit", amount: 0 }],
          credits: [{ direction: "Credit", amount: 0 }]
        }
      }
      this.drawer = true
    },
    editItem(value) {
      this.drawer = true
      this.editedItem = value

      if (this.editedItem.type == "Normal") {
        this.editedItem.paymentAccountId = this.editedItem.paymentLedger.account.id
        this.editedItem.entryAccountId = this.editedItem.entryLedger.account.id
        this.editedItem.taxes = this.editedItem.taxLedgers
        // this.calculateTaxInfo()
        this.entryAccount = this.editedItem.entryLedger.account
      } else if (this.editedItem.type == "Journal") {
        this.editedItem = {
          ...this.editedItem,
          ...{ debits: [], credits: [] }
        }
        this.editedItem.ledgers.forEach(item => {
          item.accountId = item.account.id
          if (item.direction == "Credit") {
            this.editedItem.credits.push(item)
          } else {
            this.editedItem.debits.push(item)
          }
        })
        this.updateJournalAmount()
      }
    },
    updateIsReviewed() {
      this.editedItem.isReviewed = !this.editedItem.isReviewed
      this.saveItem()
    },
    saveItem() {
      this.$refs.transactionform.validate()
      if (this.formValid) {
        if (this.editedItem.id === undefined) {
          this.createTransaction()
        } else {
          this.updateTransaction()
        }
      }
    },
    transferTransactionDataFormat() {
      var data = {}
      if (this.editedItem.type == "Normal") {
        data = {
          type: this.editedItem.type,
          isReviewed: this.editedItem.isReviewed,
          description: this.editedItem.description,
          date: this.editedItem.date,
          paymentAction: this.editedItem.paymentAction,
          paymentAccountId: this.editedItem.paymentAccountId,
          entryAccountId: this.editedItem.entryAccountId,
          taxIds: this.editedItem.taxIds,
          amount: this.editedItem.amount,
          customerId: this.editedItem.customerId,
          vendorId: this.editedItem.vendorId,
          note: this.editedItem.note
        }
        if (data.paymentAccountId == data.entryAccountId) {
          return {
            result: false,
            data: "Messages.__DuplicateAccountError"
          }
        }
      } else if (this.editedItem.type == "Journal") {
        if (this.unbalanced) {
          return {
            result: false,
            data: "Transactions.__UnbalancedNote"
          }
        }
        this.editedItem.ledgers = [...this.editedItem.debits, ...this.editedItem.credits]
        data = {
          type: this.editedItem.type,
          isReviewed: this.editedItem.isReviewed,
          description: this.editedItem.description,
          date: this.editedItem.date,
          ledgers: this.editedItem.ledgers,
          note: this.editedItem.note
        }
        var accoundIds = []
        for (var ledger of data.ledgers) {
          if (accoundIds.includes(ledger.accountId)) {
            return {
              result: false,
              data: "Messages.__DuplicateAccountError"
            }
          } else {
            accoundIds.push(ledger.accountId)
          }
        }
      }
      if (this.editedItem.id) {
        data["id"] = this.editedItem.id
      }
      return { result: true, data: data }
    },
    updateTransaction() {
      var { result, data } = this.transferTransactionDataFormat()
      if (!result) {
        this.$store.dispatch("global/showAlertError", this.$t(data))
        return
      }

      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("transactions/updateTransaction", data)
        .then(
          function(response) {
            this.getTransactions()
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyUpdated"))
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    createTransaction() {
      var { result, data } = this.transferTransactionDataFormat()
      if (!result) {
        this.$store.dispatch("global/showAlertError", this.$t(data))
        return
      }

      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("transactions/createTransaction", data)
        .then(
          function(response) {
            this.editedItem.id = response.data
            this.getTransactions()
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyCreated"))
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    addLedgerItem(type) {
      if (type == "Credit") {
        this.editedItem.credits.push({
          direction: type,
          amount: 0
        })
      } else {
        this.editedItem.debits.push({
          direction: type,
          amount: 0
        })
      }
    },
    deleteLedgerItem(type, idx) {
      var ledgers = []
      if (type == "Credit") {
        ledgers = this.editedItem.credits
      } else {
        ledgers = this.editedItem.debits
      }
      ledgers.splice(idx, 1)
      this.updateJournalAmount()
    },
    updateJournalAmount() {
      var debitAmount = 0
      var creditAmount = 0

      for (var ledger_credit of this.editedItem.credits) {
        creditAmount += ledger_credit.amount
      }

      for (var ledger_debit of this.editedItem.debits) {
        debitAmount += ledger_debit.amount
      }

      // for (var ledger of this.editedItem.ledgers) {
      //     if (ledger.direction == "Debit") {
      //         debitAmount += ledger.amount
      //     } else if (ledger.direction == "Credit") {
      //         creditAmount += ledger.amount
      //     }
      // }
      this.editedItem.totalDebitAmount = debitAmount
      this.editedItem.totalCreditAmount = creditAmount
      if (debitAmount != creditAmount) {
        this.editedItem.total = this.$t("Transactions.__Unbalanced")
        this.unbalanced = true
      } else {
        this.editedItem.total = debitAmount
        this.unbalanced = false
      }
    },
    closeEdit() {
      this.drawer = false
      this.editedItem = { dateMenu: false, taxes: [] }
    },
    clearFilterDialog() {
      this.filters = {}
      this.filterItem = {
        dates: []
      }
    },
    async deleteEditTransaction() {
      this.$store.dispatch("global/startLoading")
      this.deleteDialog = false
      var result = await this.deleteTransaction(this.editedItem.id)
      this.drawer = false
      this.getTransactions()
      this.$store.dispatch("global/stopLoading")
    },
    deleteTransaction(id) {
      return this.$store
        .dispatch("transactions/deleteTransaction", id)
        .then(
          function(response) {
            return Promise.resolve(true)
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
            return Promise.reject(error)
          }.bind(this)
        )
    },
    async batchDelectTranctions() {
      var functions = []
      this.selected.forEach(item => {
        functions.push(this.deleteTransaction(item.id))
      })
      var result = await Promise.all(functions)

      var success = true
      for (var r of result) {
        if (r == false) success = false
      }

      this.drawer = false
      this.getTransactions()

      if (success) {
        this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyDeleted"))
      }
    },
    duplicateTransaction() {
      this.$store
        .dispatch("transactions/duplicateTransaction", this.editedItem.id)
        .then(
          function(response) {
            this.$store.dispatch("global/stopLoading")
            this.getTransactions()
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyDuplicated"))
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
    },
    taxesUpdated() {
      this.editedItem.taxIds = this.editedItem.taxes.map(tax => tax.id)
      this.calculateTaxInfo()
    },
    calculateTaxInfo() {
      this.totlaTaxesAmount = 0
      this.beforeTaxesAmount = 0

      var taxes = this.editedItem.taxes

      var totalRate = 0
      var tax
      for (tax of taxes) {
        totalRate += tax.rate
      }
      var beforeTaxesAmount = this.editedItem.amount / (1 + totalRate / 100)

      var totlaTaxesAmount = 0
      taxes.map(tax => {
        tax.amount = parseFloat((beforeTaxesAmount * tax.rate) / 100)
        totlaTaxesAmount += tax.amount
      })

      this.totlaTaxesAmount = totlaTaxesAmount
      this.beforeTaxesAmount = this.editedItem.amount - totlaTaxesAmount

      this.editedItem.taxes = taxes
    },
    filterAction() {},
    cancelFilterDialog() {
      this.filterDialog = false
    },
    filterTransactions() {
      this.drawer = false
      this.filters = {}

      // dates
      if (this.filterItem.dates.length > 0) {
        this.filterItem.dates.sort()
        this.filters.from = this.filterItem.dates[0]
        this.filters.to = this.filterItem.dates.length == 2 ? this.filterItem.dates[1] : this.filterItem.dates[0]
      }

      //status
      if (this.filterItem.status && this.filterItem.status != "") {
        this.filters.status = this.filterItem.status
      }

      //type
      var typeArr = []
      if (this.filterItem.isDesposit) {
        typeArr.push("Deposit")
      }
      if (this.filterItem.isJournal) {
        typeArr.push("Journal")
      }
      if (this.filterItem.isWithdraw) {
        typeArr.push("Withdraw")
      }
      if (typeArr.length > 0) {
        this.filters.type = typeArr.join(",")
      }

      this.getTransactions()

      this.filterDialog = false
    },
    getRowClass(item) {
      return this.editedItem.id == item.id ? "is-editing" : ""
    }
  },
  computed: {
    dateRangeText() {
      return this.filterItem.dates
        .slice()
        .sort()
        .join(" ~ ")
    },
    drawerTitle() {
      var title =
        this.editedItem.id == undefined ? this.$t("Transactions.__AddTransaction") : this.$t("Transactions.__EditTransaction")

      if (this.editedItem.type == "Journal") {
        title = title + " - " + this.$t("Transactions.__Journal")
      } else if (this.editedItem.paymentAction == "Withdraw") {
        title = title + " - " + this.$t("Transactions.__Withdraw")
      } else if (this.editedItem.paymentAction == "Deposit") {
        title = title + " - " + this.$t("Transactions.__Deposit")
      }

      return title
    }
  },
  watch: {
    drawer(value) {
      if (this.$refs.transactionform || !value) this.$refs.transactionform.reset()
    },
    options: {
      handler() {
        this.getTransactions()
      },
      deep: true
    }
  },
  mounted() {
    var transactionId = this.$route.query.id
    if (transactionId) {
      this.getTransaction(transactionId)
    }
  },

  created() {
    // this.getTransactions()
  }
}
</script>
<style lang="scss" scope>
tr.selectable {
  cursor: pointer;
}

.is-editing {
  background-color: #eeeeee;
}
</style>
